import {Questionnaire} from 'one.models/lib/models/QuestionnaireModel';

export const QuestionnaireBI: Questionnaire = {
    resourceType: 'Questionnaire',
    language: 'en',
    url: 'http://uk-erlangen.de/freeda/questionnaire/BI_en',
    name: 'BI',
    status: 'active',
    item: [
        {
            linkId: 'pastInfYN',
            prefix: 'BI1',
            text: 'Have you been infected with SARS-CoV-2 in the past?',
            type: 'choice',
            answerOption: [
                {
                    valueCoding: {
                        system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                        version: '1.0',
                        code: '0',
                        display: 'No'
                    }
                },
                {
                    valueCoding: {
                        system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                        version: '1.0',
                        code: '1',
                        display: 'Yes'
                    }
                }
            ]
        },
        {
            linkId: 'pInfDate',
            prefix: 'BI2',
            text: 'Do you remember when you tested positive for SARS-CoV-2 infection?',
            type: 'date',
            enableWhen: [
                {
                    question: 'pastInfYN',
                    operator: '=',
                    answerCoding: {
                        code: '1'
                    }
                }
            ],
            answerRestriction: {
                maxValue: {
                    valueDate: 'now'
                }
            }
        },
        {
            linkId: 'pInfCuYNU',
            prefix: 'BI3',
            text: 'Had you been hospitalized because of your past SARS-CoV-2 infection?',
            type: 'choice',
            enableWhen: [
                {
                    question: 'pastInfYN',
                    operator: '=',
                    answerCoding: {
                        code: '1'
                    }
                }
            ],
            answerOption: [
                {
                    valueCoding: {
                        system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                        version: '1.0',
                        code: '0',
                        display: 'No'
                    }
                },
                {
                    valueCoding: {
                        system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                        version: '1.0',
                        code: '1',
                        display: 'Yes'
                    }
                },
                {
                    valueCoding: {
                        system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                        version: '1.0',
                        code: '999',
                        display: 'I do not know'
                    }
                }
            ]
        },
        {
            linkId: 'BI4_0',
            prefix: 'BI4_0',
            text: 'In what kind of ward were you treated? (multiple answers possible)',
            type: 'group',
            enableWhen: [
                {
                    question: 'pInfCuYNU',
                    operator: '=',
                    answerCoding: {
                        code: '1'
                    }
                }
            ],
            item: [
                {
                    linkId: 'pInfIntensCUYNU',
                    prefix: 'BI4_1',
                    type: 'choice',
                    text: 'Intensive Care Unit (ICU)?',
                    answerOption: [
                        {
                            valueCoding: {
                                system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                                version: '1.0',
                                code: '0',
                                display: 'No'
                            }
                        },
                        {
                            valueCoding: {
                                system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                                version: '1.0',
                                code: '1',
                                display: 'Yes'
                            }
                        },
                        {
                            valueCoding: {
                                system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                                version: '1.0',
                                code: '999',
                                display: 'I do not know'
                            }
                        }
                    ]
                },
                {
                    linkId: 'pInfIsolInfCUYNU',
                    prefix: 'BI4_2',
                    type: 'choice',
                    text: 'Isolation or infection ward?',
                    answerOption: [
                        {
                            valueCoding: {
                                system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                                version: '1.0',
                                code: '0',
                                display: 'No'
                            }
                        },
                        {
                            valueCoding: {
                                system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                                version: '1.0',
                                code: '1',
                                display: 'Yes'
                            }
                        },
                        {
                            valueCoding: {
                                system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                                version: '1.0',
                                code: '999',
                                display: 'I do not know'
                            }
                        }
                    ]
                },
                {
                    linkId: 'pInfOtherCU_txt',
                    prefix: 'BI4_3',
                    type: 'string',
                    maxLength: 1000,
                    text: 'others'
                }
            ]
        },
        {
            linkId: 'pInfSymptYNU',
            prefix: 'BI5',
            type: 'choice',
            text: 'Remember please, did you have symptoms due to SARS-CoV-2 infection?',
            enableWhen: [
                {
                    question: 'pastInfYN',
                    operator: '=',
                    answerCoding:
                        {
                        code: '1'
                    }
                }
            ],
            answerOption: [
                {
                    valueCoding: {
                        system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                        version: '1.0',
                        code: '0',
                        display: 'No'
                    }
                },
                {
                    valueCoding: {
                        system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                        version: '1.0',
                        code: '1',
                        display: 'Yes'
                    }
                },
                {
                    valueCoding: {
                        system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                        version: '1.0',
                        code: '999',
                        display: 'I do not know'
                    }
                }
            ]
        },
        {
            linkId: 'BI6_0',
            prefix: 'BI6_0',
            type: 'group',
            enableWhen: [
                {
                    question: 'pInfSymptYNU',
                    operator: '=',
                    answerCoding: {
                        code: '1'
                    }
                }
            ],
            item: [
                {
                    linkId: 'pInfDurOfSympt_N',
                    prefix: 'BI6_1',
                    type: 'integer',
                    text: 'How long (in days) have you had symptoms?',
                    enableWhen: [
                        {
                            question: 'pInfDurOfSymptUk',
                            operator: '!=',
                            answerCoding: {
                                code: '1'
                            }
                        }
                    ],
                    answerRestriction: {
                        minValue: {
                            valueInteger: '0'
                        },
                        maxValue: {
                            valueInteger: '100'
                        }
                    }
                },
                {
                    linkId: 'pInfDurOfSymptUk',
                    prefix: 'BI6_2',
                    type: 'open-choice',
                    required: false,
                    answerOption: [
                        {
                            valueCoding: {
                                system: 'http://uk-erlangen.de/freeda/valueCoding/DoNotKnow_en',
                                version: '1.0',
                                code: '1',
                                display: 'I do not know'
                            }
                        }
                    ]
                }
            ]
        },
        {
            linkId: 'pInfPneumoniaYNU',
            prefix: 'BI7',
            type: 'choice',
            text: 'Have you been diagnosed with pneumonia?',
            enableWhen: [
                {
                    question: 'pastInfYN',
                    operator: '=',
                    answerCoding: {
                        code: '1'
                    }
                }
            ],
            answerOption: [
                {
                    valueCoding: {
                        system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                        version: '1.0',
                        code: '0',
                        display: 'No'
                    }
                },
                {
                    valueCoding: {
                        system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                        version: '1.0',
                        code: '1',
                        display: 'Yes'
                    }
                },
                {
                    valueCoding: {
                        system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                        version: '1.0',
                        code: '999',
                        display: 'I do not know'
                    }
                }
            ]
        },
        {
            linkId: 'pInfTreatYNU',
            prefix: 'BI8',
            type: 'choice',
            text: 'Did you receive treatment for the SARS-CoV-2 infection?',
            enableWhen: [
                {
                    question: 'pInfCuYNU',
                    operator: '=',
                    answerCoding: {
                        code: '1'
                    }
                }
            ],
            answerOption: [
                {
                    valueCoding: {
                        system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                        version: '1.0',
                        code: '0',
                        display: 'No'
                    }
                },
                {
                    valueCoding: {
                        system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                        version: '1.0',
                        code: '1',
                        display: 'Yes'
                    }
                },
                {
                    valueCoding: {
                        system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                        version: '1.0',
                        code: '999',
                        display: 'I do not know'
                    }
                }
            ]
        },
        {
            linkId: 'BI9_0',
            prefix: 'BI9_0',
            text: 'Have you received any of the following treatments?',
            type: 'group',
            enableWhen: [
                {
                    question: 'pInfTreatYNU',
                    operator: '=',
                    answerCoding: {
                        code: '1'
                    }
                }
            ],
            item: [
                {
                    linkId: 'pInfOxygenYNU',
                    prefix: 'BI9_1',
                    type: 'choice',
                    text: 'Did you get oxygen?',
                    answerOption: [
                        {
                            valueCoding: {
                                system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                                version: '1.0',
                                code: '0',
                                display: 'No'
                            }
                        },
                        {
                            valueCoding: {
                                system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                                version: '1.0',
                                code: '1',
                                display: 'Yes'
                            }
                        },
                        {
                            valueCoding: {
                                system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                                version: '1.0',
                                code: '999',
                                display: 'I do not know'
                            }
                        }
                    ]
                },
                {
                    linkId: 'pInfInfusionYNU',
                    prefix: 'BI9_2',
                    type: 'choice',
                    text: 'Did you get an infusion?',
                    answerOption: [
                        {
                            valueCoding: {
                                system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                                version: '1.0',
                                code: '0',
                                display: 'No'
                            }
                        },
                        {
                            valueCoding: {
                                system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                                version: '1.0',
                                code: '1',
                                display: 'Yes'
                            }
                        },
                        {
                            valueCoding: {
                                system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                                version: '1.0',
                                code: '999',
                                display: 'I do not know'
                            }
                        }
                    ]
                },
                {
                    linkId: 'pInfAntibioticYNU',
                    prefix: 'BI9_3',
                    type: 'choice',
                    text: 'Have you received antibiotics?',
                    answerOption: [
                        {
                            valueCoding: {
                                system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                                version: '1.0',
                                code: '0',
                                display: 'No'
                            }
                        },
                        {
                            valueCoding: {
                                system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                                version: '1.0',
                                code: '1',
                                display: 'Yes'
                            }
                        },
                        {
                            valueCoding: {
                                system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                                version: '1.0',
                                code: '999',
                                display: 'I do not know'
                            }
                        }
                    ]
                },
                {
                    linkId: 'pInfQuensylYNU',
                    prefix: 'BI9_4',
                    type: 'choice',
                    text: 'Were you / are you treated with hydroxychloroquine (Quensyl®)?',
                    answerOption: [
                        {
                            valueCoding: {
                                system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                                version: '1.0',
                                code: '0',
                                display: 'No'
                            }
                        },
                        {
                            valueCoding: {
                                system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                                version: '1.0',
                                code: '1',
                                display: 'Yes'
                            }
                        },
                        {
                            valueCoding: {
                                system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                                version: '1.0',
                                code: '999',
                                display: 'I do not know'
                            }
                        }
                    ]
                },
                {
                    linkId: 'pInfRemdesivirYNU',
                    prefix: 'BI9_5',
                    type: 'choice',
                    text: 'Have you been treated with remdesivir?',
                    answerOption: [
                        {
                            valueCoding: {
                                system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                                version: '1.0',
                                code: '0',
                                display: 'No'
                            }
                        },
                        {
                            valueCoding: {
                                system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                                version: '1.0',
                                code: '1',
                                display: 'Yes'
                            }
                        },
                        {
                            valueCoding: {
                                system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                                version: '1.0',
                                code: '999',
                                display: 'I do not know'
                            }
                        }
                    ]
                },
                {
                    linkId: 'pInfIntubationYNU',
                    prefix: 'BI9_6',
                    type: 'choice',
                    text: 'Have you been given artificial respiration (intubation)?',
                    answerOption: [
                        {
                            valueCoding: {
                                system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                                version: '1.0',
                                code: '0',
                                display: 'No'
                            }
                        },
                        {
                            valueCoding: {
                                system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                                version: '1.0',
                                code: '1',
                                display: 'Yes'
                            }
                        },
                        {
                            valueCoding: {
                                system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                                version: '1.0',
                                code: '999',
                                display: 'I do not know'
                            }
                        }
                    ]
                }
            ]
        },
        {
            linkId: 'pInfCovStudyYNU',
            prefix: 'BI10',
            type: 'choice',
            text: 'Have you participated in a study on a (new) COVID therapy?',
            enableWhen: [
                {
                    question: 'pastInfYN',
                    operator: '=',
                    answerCoding: {
                        code: '1'
                    }
                }
            ],
            answerOption: [
                {
                    valueCoding: {
                        system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                        version: '1.0',
                        code: '0',
                        display: 'No'
                    }
                },
                {
                    valueCoding: {
                        system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                        version: '1.0',
                        code: '1',
                        display: 'Yes'
                    }
                },
                {
                    valueCoding: {
                        system: 'http://uk-erlangen.de/freeda/valueCoding/YesNo_en',
                        version: '1.0',
                        code: '999',
                        display: 'I do not know'
                    }
                }
            ]
        },
        {
            linkId: 'BI11_0',
            prefix: 'BI11_0',
            type: 'group',
            enableWhen: [
                {
                    question: 'pInfCovStudyYNU',
                    operator: '=',
                    answerCoding: {
                        code: '1'
                    }
                }
            ],
            item: [
                {
                    linkId: 'pInfStudyName_txt',
                    prefix: 'BI11_1',
                    type: 'string',
                    text: 'What is the name of the study?',
                    maxLength: 1000,
                    enableWhen: [
                        {
                            question: 'pInfStudyNameUk',
                            operator: '!=',
                            answerCoding: {
                                code: '1'
                            }
                        }
                    ]
                },
                {
                    linkId: 'pInfStudyNameUk',
                    prefix: 'BI11_2',
                    type: 'open-choice',
                    required: false,
                    answerOption: [
                        {
                            valueCoding: {
                                system: 'http://uk-erlangen.de/freeda/valueCoding/DoNotKnow_en',
                                version: '1.0',
                                code: '1',
                                display: 'I do not know'
                            }
                        }
                    ]
                }
            ]
        },
        {
            linkId: 'BI12_0',
            prefix: 'BI12_0',
            type: 'group',
            enableWhen: [
                {
                    question: 'pInfCovStudyYNU',
                    operator: '=',
                    answerCoding: {
                        code: '1'
                    }
                }
            ],
            item: [
                {
                    linkId: 'pInfStTherapy_txt',
                    prefix: 'BI11_1',
                    type: 'string',
                    text: 'Which COVID therapy or medication did you receive in this study?',
                    maxLength: 1000,
                    enableWhen: [
                        {
                            question: 'pInfStTherapyUk',
                            operator: '!=',
                            answerCoding: {
                                code: '1'
                            }
                        }
                    ]
                },
                {
                    linkId: 'pInfStTherapyUk',
                    prefix: 'BI11_2',
                    type: 'open-choice',
                    required: false,
                    answerOption: [
                        {
                            valueCoding: {
                                system: 'http://uk-erlangen.de/freeda/valueCoding/DoNotKnow_en',
                                version: '1.0',
                                code: '1',
                                display: 'I do not know'
                            }
                        }
                    ]
                }
            ]
        }
    ]
};
